import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect } from "react";
import TextInput from "components/files/TextInput";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomIconButton from "components/CustomIconButton";
import { Add, Close, Done } from "@mui/icons-material";
import CustomCard from "components/CustomCard";
import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import CustomDataGrid from "components/customDataGrid";
import { useState } from "react";
import TimePickerInput from "components/files/TimePickerInput";
import DatePickerInput from "components/files/DatePickerInput";
import CheckBoxInput from "components/files/CheckBoxInput";
import CustomDialog from "components/CustomDialog";
import http from "../../../../http";
import { apiUrl } from "config/settings";
import { endpointName } from "containers/servicesCall/const";
import useDataManager from "hooks/useDataManager";
import { DATE_FORMAT, TIME_FORMAT } from "config/const";

const Works = ({ data, list, setList }) => {
    const { bt } = useBizTypeTranslation();
    const { addItem, editItem } = useDataManager();
    const user = useSelector((state) => state?.userSettings?.user);
    const { reset, handleSubmit, control, formState: { errors } } = useForm();
    const [openDialog, setOpenDialog] = useState(false)

    const openWork = (work) => {
        const startMoment = moment(work?.start)
        const endMoment = moment(work?.end)
        reset({
            ...work,
            id: work?._id,
            date: startMoment?.clone().startOf('day'),
            startTime: startMoment?.clone(),
            endTime: endMoment?.clone(),
        })

        setOpenDialog(true)
    }

    const onSubmitWork = (values) => {
        try {
            const endTime = moment(values?.endTime)
            const startTime = moment(values?.startTime)

            const work = {
                ...values,
                employeeName: `${user?.fn} ${user?.ln}`,
                start: values?.date?.clone().set({
                    hour: startTime.hour(),
                    minute: startTime.minute(),
                    second: startTime.second(),
                    millisecond: 0,
                }),
                end: values?.date?.clone().set({
                    hour: endTime.hour(),
                    minute: endTime.minute(),
                    second: endTime.second(),
                    millisecond: 0,
                })
            }

            http.patch(`${apiUrl}/${endpointName}/${values?.id ? "updateWork" : "createWork"}/${data?.id}`, work)
                .then(res => {
                    if (work?.id) setList(editItem(work, list))
                    else setList(addItem(res?.data, list))
                })
            closeDialog()

        }
        catch (error) {
            console.log("error", error);
        }
    }

    const closeDialog = () => {
        reset({ date: moment(), startTime: null, endTime: moment(), desc: "", continual: false })
        setOpenDialog(false)
    }

    return (
        <CustomCard width="100%">
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography fontSize={14}>{bt("WORKS")}:</Typography>
                <CustomIconButton hideBgcolor icon={<Add />} size={30} onClick={() => setOpenDialog(true)} />
            </Stack>

            <CustomDataGrid
                width="100%"
                minHeight={50}
                setItem={(i) => openWork(i)}
                list={list?.map((w) => ({ ...w, id: w?._id, })
                )}
                columns={[
                    {
                        field: 'employeeName',
                        headerName: bt("EMPLOYEE"),
                        width: 100,
                        filterable: false,
                    },
                    {
                        field: 'desc',
                        headerName: bt("DESC"),
                        width: 260,
                        filterable: false,
                    },
                    {
                        field: 'date',
                        headerName: bt("DATE"),
                        width: 120,
                        filterable: false,
                        renderCell: (values) => {
                            const date = moment(values?.row?.start)?.clone().startOf('day')
                            return (
                                moment(date).format(DATE_FORMAT)
                            )
                        },
                    },
                    {
                        field: 'startTime',
                        headerName: bt("START_TIME"),
                        width: 80,
                        filterable: false,
                        renderCell: (values) => {
                            const startTime = moment(values?.row?.start)?.clone()
                            return (
                                moment(startTime).format(TIME_FORMAT)
                            )
                        },
                    },
                    {
                        field: 'endTime',
                        headerName: bt("END_TIME"),
                        width: 80,
                        filterable: false,
                        renderCell: (values) => {
                            const startTime = moment(values?.row?.end)?.clone()
                            return (
                                moment(startTime).format(TIME_FORMAT)
                            )
                        },
                    },
                    {
                        field: 'continual',
                        headerName: bt("CONTINUAL"),
                        width: 100,
                        filterable: false,
                        renderCell: (values) => {
                            return (
                                values?.row?.continual
                                    ? <Done fontSize="small" sx={{ color: "success.main" }} />
                                    : ""
                            )
                        },
                    },
                ]}
                hideFooter
            />

            <CustomDialog
                title="WORK"
                open={openDialog}
                onClose={() => closeDialog()}
                actionBtn={{ title: bt("SAVE"), onClick: () => handleSubmit(onSubmitWork)() }}
            >
                <form onSubmit={handleSubmit(onSubmitWork)}>

                    <Stack spacing={2}>
                        <DatePickerInput
                            control={control}
                            defaultValue={moment()}
                            name={`date`}
                            title="DATE"
                        />

                        <TimePickerInput
                            control={control}
                            name={`startTime`}
                            title="START_TIME"
                        />

                        <TimePickerInput
                            defaultValue={moment()}
                            control={control}
                            name={`endTime`}
                            title="END_TIME"
                        />

                        <TextInput
                            addFlex
                            width="100%"
                            fullWidth
                            control={control}
                            errors={errors}
                            name={`desc`}
                            rows={2}
                            title="DESC"
                        />

                        <CheckBoxInput
                            width={110}
                            control={control}
                            defaultValue={false}
                            name={`continual`}
                            title={"CONTINUAL"}
                        />
                    </Stack>

                </form>
            </CustomDialog>
        </CustomCard>
    )
};

export default Works;
